import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { status } from 'constants/general';
import doctorsStrings from 'modules/doctors/strings';
import DoctorsHeader from 'modules/doctors/components/DoctorsHeader';
import DoctorsFilter from 'modules/doctors/components/DoctorsFilter';
import DoctorsList from 'modules/doctors/components/DoctorsList';
import Loader from 'modules/common/components/Loader';
import Pagination from 'modules/common/components/Pagination';
import Popup from 'modules/common/components/Popup';

import {
  DoctorsWrapper,
  LoaderWrapper,
  NoResultsWrapper,
  NoResultsText,
  PaginationWrapper,
  ImgPreview,
  ToastTextOverlay,
} from './DoctorsComponent.style';

const DoctorsComponent = ({
  showCopiedTextOverlay,
  selectedStatusFilter,
  searchQuery,
  selectedPageFilter,
  isPreviewFilePopupOpen,
  previewFileUrl,
  isActionPopupOpen,
  isActionPopupLoading,
  actionPopupStatus,
  isBadgePopupOpen,
  isBadgePopupLoading,
  badgePopupTarget,
  loadedDoctorsBadges,
  handleTextToCopyToClipboardClick,
  handleDoctorStatusFilterClick,
  handleSearchBarInputChange,
  handleDoctorsPaginationClick,
  handlePreviewFileClick,
  handleActionBtnClick,
  handleActionPopupConfirmBtnClick,
  handleActionPopupDismissBtnClick,
  handleBadgeBtnClick,
  handleBadgePopupConfirmBtnClick,
  handleBadgePopupDismissBtnClick,
}) => {
  const { staticData, doctorsList } = useSelector(state => ({
    staticData: state.common.staticData,
    doctorsList: state.doctors.doctorsList,
  }));

  const totalResultsCount = doctorsList?.details?.totalCount;
  const numberOfPages = (totalResultsCount && Math.ceil(totalResultsCount / 10)) || 1;
  const doctorsListArr = doctorsList?.details?.results;

  const renderDoctorsList = () => {
    if (
      doctorsList.status === status.SHOULD_CALL_API ||
      doctorsList.status === status.FETCHING ||
      staticData.status === status.SHOULD_CALL_API ||
      staticData.status === status.FETCHING
    )
      return (
        <LoaderWrapper>
          <Loader />
        </LoaderWrapper>
      );

    if (doctorsList.status === status.SUCCESS && doctorsListArr?.length > 0)
      return (
        <>
          <DoctorsList
            doctorsListArr={doctorsListArr}
            isActionPopupOpen={isActionPopupOpen}
            isActionPopupLoading={isActionPopupLoading}
            actionPopupStatus={actionPopupStatus}
            isBadgePopupOpen={isBadgePopupOpen}
            isBadgePopupLoading={isBadgePopupLoading}
            badgePopupTarget={badgePopupTarget}
            loadedDoctorsBadges={loadedDoctorsBadges}
            handleTextToCopyToClipboardClick={handleTextToCopyToClipboardClick}
            handlePreviewFileClick={handlePreviewFileClick}
            handleActionBtnClick={handleActionBtnClick}
            handleActionPopupConfirmBtnClick={handleActionPopupConfirmBtnClick}
            handleActionPopupDismissBtnClick={handleActionPopupDismissBtnClick}
            handleBadgeBtnClick={handleBadgeBtnClick}
            handleBadgePopupConfirmBtnClick={handleBadgePopupConfirmBtnClick}
            handleBadgePopupDismissBtnClick={handleBadgePopupDismissBtnClick}
          />
          {numberOfPages > 1 && (
            <PaginationWrapper>
              <Pagination
                currentPage={selectedPageFilter}
                totalCount={numberOfPages}
                handlePaginationClick={handleDoctorsPaginationClick}
              />
            </PaginationWrapper>
          )}
          {isPreviewFilePopupOpen && (
            <Popup handleCloseBtnClick={() => handlePreviewFileClick(false)}>
              <ImgPreview src={previewFileUrl} />
            </Popup>
          )}
          {showCopiedTextOverlay && (
            <ToastTextOverlay>{doctorsStrings.doctorsList.copiedToClipboardText}</ToastTextOverlay>
          )}
        </>
      );

    return (
      <NoResultsWrapper>
        <NoResultsText>{doctorsStrings.doctorsList.doctorsGridNoResultsFound}</NoResultsText>
      </NoResultsWrapper>
    );
  };

  return (
    <>
      <DoctorsHeader
        selectedStatusFilter={selectedStatusFilter}
        handleDoctorStatusFilterClick={handleDoctorStatusFilterClick}
      />
      <DoctorsWrapper>
        <DoctorsFilter
          searchQuery={searchQuery}
          handleSearchBarInputChange={handleSearchBarInputChange}
        />
        {renderDoctorsList()}
      </DoctorsWrapper>
    </>
  );
};

DoctorsComponent.propTypes = {
  showCopiedTextOverlay: PropTypes.bool.isRequired,
  selectedStatusFilter: PropTypes.number.isRequired,
  searchQuery: PropTypes.string.isRequired,
  selectedPageFilter: PropTypes.number.isRequired,
  isPreviewFilePopupOpen: PropTypes.bool.isRequired,
  previewFileUrl: PropTypes.string.isRequired,
  isActionPopupOpen: PropTypes.bool.isRequired,
  isActionPopupLoading: PropTypes.bool.isRequired,
  actionPopupStatus: PropTypes.string.isRequired,
  isBadgePopupOpen: PropTypes.bool.isRequired,
  isBadgePopupLoading: PropTypes.bool.isRequired,
  badgePopupTarget: PropTypes.string.isRequired,
  loadedDoctorsBadges: PropTypes.shape({}).isRequired,
  handleTextToCopyToClipboardClick: PropTypes.func.isRequired,
  handleDoctorStatusFilterClick: PropTypes.func.isRequired,
  handleSearchBarInputChange: PropTypes.func.isRequired,
  handleDoctorsPaginationClick: PropTypes.func.isRequired,
  handlePreviewFileClick: PropTypes.func.isRequired,
  handleActionBtnClick: PropTypes.func.isRequired,
  handleActionPopupConfirmBtnClick: PropTypes.func.isRequired,
  handleActionPopupDismissBtnClick: PropTypes.func.isRequired,
  handleBadgeBtnClick: PropTypes.func.isRequired,
  handleBadgePopupConfirmBtnClick: PropTypes.func.isRequired,
  handleBadgePopupDismissBtnClick: PropTypes.func.isRequired,
};

export default DoctorsComponent;
